export const IngresosItems = {
    header: [{ value: "Concepto" }, { value: "Precio promedio" }, { value: "Cantidad" }, { value: "Total" }],
}

export const RoomReservasItems = {
    header: [{ value: "Concepto" }, { value: "Cantidad" }, { value: "Total" }],
}

export const RoomCancelacionesItems = {
    header: [{ value: "Concepto" }, { value: "Pagadas" }, { value: "Monto" }, { value: "No pagadas" }, { value: "Monto" }],
}

export const FajillasItems = {
    header: [{ value: "Concepto" }, { value: "Cantidad" }, { value: "Monto" }, { value: "Total" }],
}

export const GastosItems = {
    header: [{ value: "Fondo de caja" }, { value: "Total" }],
}

export const PropinasItems = {
    header: [{ value: "Concepto" }, { value: "Cantidad" }, { value: "Total" }],
}

export const IncidenciasItems = {
    header: [
        { value: "#" },
        { value: "Estatus" },
        { value: "Descripción" },
        { value: "Severidad" },
        { value: "Área" },
        { value: "Habitación" },
    ],
}
